import React from 'react';
import { Box } from '@mui/material';
import {
  Gavel as GavelIcon,
  People as PeopleIcon,
  AttachMoney as MoneyIcon,
  TrendingUp as TrendingUpIcon,
  CalendarToday as CalendarIcon,
  Assignment as TaskIcon,
  SupervisorAccount as SupervisorIcon,
} from '@mui/icons-material';
import { LawyerStats } from '../../../types/statistics';
import { StatCard } from '../StatCard';
import { DashboardTabs } from '../DashboardTabs';

interface LawyerViewProps {
  data: LawyerStats;
}

export const LawyerView: React.FC<LawyerViewProps> = ({ data }) => {
  return (
    <DashboardTabs overviewType="lawyer">
      <Box sx={{ display: 'flex', flexWrap: 'wrap', mx: -1.5 }}>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="My Active Cases"
            value={data.my_active_cases}
            icon={<GavelIcon />}
            color="#2563eb"
          />
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="My Total Cases"
            value={data.my_total_cases}
            icon={<GavelIcon />}
            color="#9333ea"
          />
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="My Completed Cases"
            value={data.my_completed_cases}
            icon={<TaskIcon />}
            color="#16a34a"
          />
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="My Clients"
            value={data.my_clients}
            icon={<PeopleIcon />}
            color="#dc2626"
          />
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Supervised Cases"
            value={data.supervised_cases}
            icon={<SupervisorIcon />}
            color="#7c3aed"
          />
        </Box>
      </Box>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', mx: -1.5 }}>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="My Success Rate"
            value={data.my_success_rate}
            icon={<TrendingUpIcon />}
            color="#16a34a"
          />
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="My Monthly Revenue"
            value={data.my_monthly_revenue}
            icon={<MoneyIcon />}
            color="#059669"
          />
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Avg Case Duration"
            value={data.average_case_duration}
            icon={<CalendarIcon />}
            color="#2563eb"
          />
        </Box>
      </Box>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', mx: -1.5 }}>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="My Pending Tasks"
            value={data.my_pending_tasks}
            icon={<TaskIcon />}
            color="#2563eb"
          />
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="My Overdue Tasks"
            value={data.my_overdue_tasks}
            icon={<TaskIcon />}
            color="#dc2626"
          />
        </Box>
      </Box>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', mx: -1.5 }}>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Upcoming Hearings"
            value={data.upcoming_hearings}
            icon={<CalendarIcon />}
            color="#9333ea"
          />
        </Box>
      </Box>
    </DashboardTabs>
  );
};
